import { Button, ButtonBaseProps } from '@shared/components/Button';
import { i18n } from '@shared/util/i18n';
import { useMenuContext } from './MenuContext';

type MenuBackButtonProps = Pick<ButtonBaseProps, 'onClick' | 'testID' | 'className'>;

/**
 * Menu.BackButton
 *
 * Ghost, icon-only back arrow. Render it in a `Menu.TitleBar`'s
 * `startContent`. Closes the current menu by default, which in a submenu
 * returns to the parent; pass `onClick` for steps within a single menu.
 */

export function MenuBackButton({
  onClick,
  testID = 'menu-back-button',
  className,
}: MenuBackButtonProps) {
  const { close } = useMenuContext();
  return (
    <Button
      icon="arrow-point-left-heavy"
      iconOnly
      iconGridSize={2.75}
      variant="ghost"
      size="medium"
      label={i18n('common.back')}
      onClick={onClick ?? close}
      testID={testID}
      className={className}
    />
  );
}
